import { createFileRoute } from "@tanstack/react-router"

import { issueTypeStatusViewStaticData } from "../../../../../../../../views/IssueTypeSettingsStatusView/constants"
import { IssueTypeSettingsStatusView } from "../../../../../../../../views/IssueTypeSettingsStatusView/IssueTypeSettingsStatusView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/issue-types/$issueTypeId/statuses",
)({
	component: IssueTypeSettingsStatusView,
	staticData: issueTypeStatusViewStaticData,
})
